import React, { useState, useEffect } from 'react';
import { CoachingFormNote } from './index';
import { userData } from 'util/userData';
import { HttpRequest } from 'util/http';

interface AddNoteModalProps {
  isOpen: boolean;
  toggle: () => void;
  addNote: (rowData: Partial<CoachingFormNote>) => void;
}

const AddNoteModal: React.FC<AddNoteModalProps> = ({ isOpen, toggle, addNote }) => {
  const [formData, setFormData] = useState<Partial<CoachingFormNote>>({
    client: userData.getCurrentProject(),
    username: userData.getUserDataFromSession('username'),
  });
  const [formError, setFormError] = useState<string | null>(null);
  const [surveyOptions, setSurveyOptions] = useState<any[]>([]);

  useEffect(() => {
    getSurveys();
  }, []);

  const getSurveys = () => {
    const method = 'POST';
    const data = { client: userData.getCurrentProject() };
    HttpRequest.fetch('web/v1/surveys/get-surveys-by-client', { method, data })
      .then((res: any) => {
        if (res.data.surveys) {
          setSurveyOptions(res.data.surveys);
        }
      });
  };

  const handleSurveySelect = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedIndex = e.target.selectedIndex - 1; // -1 because of placeholder option
    if (selectedIndex >= 0) {
      const selectedSurvey = surveyOptions[selectedIndex];
      setFormData({
        ...formData,
        survey: e.target.value,
        external_data_reference: selectedSurvey.Customer || ''
      });
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = () => {
    const requiredFields = ['survey', 'external_data_reference', 'client', 'username', 'message'];
    for (const field of requiredFields) {
      if (!formData[field]) {
        setFormError(`Field "${field}" is required.`);
        return;
      }
    }
    addNote(formData);
    toggle();
  };

  useEffect(() => {
    const modalElement = document.querySelector('.modal') as HTMLElement;
    if (modalElement) {
      if (isOpen) {
        modalElement.classList.add('open');
        modalElement.style.display = 'block';
      } else {
        modalElement.classList.remove('open');
        modalElement.style.display = 'none';
      }
    }
  }, [isOpen]);

  return (
    <div className={`modal ${isOpen ? 'open' : ''} add-note-modal`} style={{ display: isOpen ? 'block' : 'none', overflow: 'scroll' }}>
      <div className="modal-content">
        <h4>Add New Note</h4>
        {formError && <div className="card-panel red lighten-4">{formError}</div>}

        <div className="row">
          <div className="input-field col s6">
            <input
              id="client"
              name="client"
              type="text"
              value={formData.client || ''}
              disabled
            />
            <label className="active" htmlFor="client">Client</label>
          </div>
          <div className="input-field col s6">
            <input
              id="username"
              name="username"
              type="text"
              value={formData.username || ''}
              disabled
            />
            <label className="active" htmlFor="username">Username</label>
          </div>
        </div>

        <div className="row">
          <div className="input-field col s6">
            <select
              id="survey"
              name="survey"
              onChange={handleSurveySelect}
              value={formData.survey || ''}
              className="browser-default" // This ensures proper styling
            >
              <option value="" disabled>Select a survey</option>
              {surveyOptions.map((survey) => (
                <option key={survey.survey_id + '_key'} value={survey.Abbr}>
                  {survey.Abbr}
                </option>
              ))}
            </select>
            <label className="active" htmlFor="survey">Survey</label>
          </div>
          <div className="input-field col s6">
            <input
              id="external_data_reference"
              name="external_data_reference"
              type="text"
              onChange={handleInputChange}
            />
            <label htmlFor="external_data_reference">External Data Reference</label>
          </div>
        </div>

        <div className="row">
          <div className="input-field col s12">
            <textarea
              id="message"
              name="message"
              className="materialize-textarea"
              onChange={handleInputChange}
            />
            <label htmlFor="message">Message</label>
          </div>
        </div>
      </div>

      <div className="modal-footer">
        <button className="btn waves-effect waves-light" onClick={handleSubmit}>
          Add Note
        </button>
        <button className="btn-flat btn-secondary" onClick={toggle}>
          Cancel
        </button>
      </div>
    </div>
  );
};

export default AddNoteModal;